import { ActionIcon, ActionIconProps } from "@mantine/core"
import { useMouse } from "@mantine/hooks"

interface EdgeRemoveButtonProps extends ActionIconProps {}

function EdgeRemoveButton(props: EdgeRemoveButtonProps) {
  const { ref, x, y } = useMouse()

  return (
    <ActionIcon
      color="dark"
      className={`pointer-events-none fixed z-50 rounded-full bg-background shadow-xl`}
      variant={"subtle"}
      size={"sm"}
      type="button"
      style={{
        top: y - 12,
        left: x - 12,
      }}
    >
      <IconIconamoonSignTimesFill className="size-4 text-fg-tertiary" />
    </ActionIcon>
  )
}

export default EdgeRemoveButton
